export default __webpack_public_path__ + "static/media/article_with_image.84470174.svg";